import _ from 'lodash';

export interface ServerError {
    FieldName: string;
    Message: string;
}


export const getErrorMessage = (error: any) => {
    let errorMessage = '';

    const responseData = error?.response ? error.response.data : error.data ? error.data : null;

    if (responseData && responseData.ResponseStatus && responseData.ResponseStatus.Message) {
        errorMessage = responseData.ResponseStatus.Message;
    } else if (error._error) {
        errorMessage = error._error;
    } else if (error.error) {
        errorMessage = error.error;
    } else if (error.message) {
        errorMessage = error.message;
    }

    if (responseData?.ResponseStatus?.Errors && responseData?.ResponseStatus?.Errors.length > 1) {
        responseData.ResponseStatus.Errors.forEach((error: ServerError) => {
            errorMessage = error.Message;
        });
    }

    return errorMessage;
};

export const getInitials = (name?: string) => {
    if (!name) return;

    return name
        .split(' ')
        .map((str) => str.toUpperCase().slice(0, 1))
        .join('');
};

export const isValidUrl = (url: string) => {
    try {
        const _url = new URL(url).href;
        return true;
    } catch (error) {
        console.warn(error);
        return false;
    }
};

export default function downloadPDF(data: BlobPart, name = 'file.pdf') {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
}

export const flattenObject = (obj = {}) => {
    const result = {};

    const flatten = (collection, prefix = '', suffix = '') => {
        _.forEach(collection, (value, key) => {
            const path = `${prefix}${key}${suffix}`;

            if (_.isArray(value)) {
                flatten(value, `${path}[`, ']');
            } else if (_.isPlainObject(value)) {
                flatten(value, `${path}.`);
            } else {
                result[path] = value;
            }
        });
    };

    flatten(obj);

    return result;
};
